
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.9497 7.05025C19.6834 9.78392 19.6834 14.2161 16.9497 16.9497C14.2161 19.6834 9.78392 19.6834 7.05025 16.9497C4.31658 14.2161 4.31658 9.78392 7.05025 7.05025C9.78392 4.31658 14.2161 4.31658 16.9497 7.05025Z","stroke":"#777D91","stroke-width":"2"}}),_c('path',{attrs:{"d":"M19.5607 17.4393C18.9749 16.8536 18.0251 16.8536 17.4393 17.4393C16.8536 18.0251 16.8536 18.9749 17.4393 19.5607L19.5607 17.4393ZM17.4393 19.5607L21.9393 24.0607L24.0607 21.9393L19.5607 17.4393L17.4393 19.5607Z","fill":"#777D91"}})])
          )
        }
      }
    